<template>
  <v-list-item
    class="sv-action-col-menu-item"
    v-bind="$attrs"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot name="item" :disabled="disabled">
      <v-list-item-content>
        <v-list-item-title>
          <slot />
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-icon>
        <v-icon v-if="icon" :color="computedIconColor"> {{ icon }} </v-icon>
      </v-list-item-icon>
    </slot>
  </v-list-item>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: "primary"
    },
    disabled: Boolean,
    loading: Boolean
  },
  computed: {
    computedIconColor() {
      if (this.disabled) return "grey lighten-1";
      return this.iconColor;
    }
  }
};
</script>
